import { oneOf, str, s as s_2, top, map } from "../.fable/Fable.Elmish.Browser.3.0.4/parser.fs.js";
import { Subscription, Model__IstSubscribed_2297AD2E, Model, Tab, Msg, Route as Route_4 } from "./Types.fs.js";
import { cons, filter, exists, empty, sumBy, tryHead, choose, map as map_2, distinct, append, tryFind, ofArray, collect } from "../.fable/fable-library.3.1.4/List.js";
import { isNullOrEmpty, toText, printf, toConsole, isNullOrWhiteSpace, replace } from "../.fable/fable-library.3.1.4/String.js";
import { defaultArg, map as map_1 } from "../.fable/fable-library.3.1.4/Option.js";
import { Cmd_map, Cmd_none, Cmd_batch, Cmd_OfFunc_result } from "../.fable/Fable.Elmish.3.1.0/cmd.fs.js";
import { add, containsKey, FSharpMap__TryFind, empty as empty_1, tryFind as tryFind_1, tryFindKey, FSharpMap__get_Item, ofSeq, toList } from "../.fable/fable-library.3.1.4/Map.js";
import { equals, compare, comparePrimitives, arrayHash, equalArrays } from "../.fable/fable-library.3.1.4/Util.js";
import { toString, parse, addMinutes as addMinutes_1 } from "../.fable/fable-library.3.1.4/Date.js";
import { Termin } from "../Domain.fs.js";
import { fableModule } from "../Global.fs.js";
import { Termine_set, Termine_get } from "./Repository.fs.js";
import { handle, query } from "./Api.fs.js";
import { Command, Query } from "../../Shared/Api.fs.js";
import { Navigation_modifyUrl } from "../.fable/Fable.Elmish.Browser.3.0.4/navigation.fs.js";

export const route = (() => {
    let parseBefore, parseBefore_2, parseBefore_4;
    const parsers = ofArray([map(new Route_4(0), (state) => top(state)), map(new Route_4(2), s_2("r")), map((arg0) => (new Route_4(3, arg0)), (parseBefore = s_2("r"), (state_2) => collect((state_1) => str(state_1), parseBefore(state_2)))), map((arg0_1) => (new Route_4(5, arg0_1)), (parseBefore_2 = s_2("p"), (state_5) => collect((state_4) => str(state_4), parseBefore_2(state_5)))), map((arg0_2) => (new Route_4(4, arg0_2)), (parseBefore_4 = s_2("s"), (state_8) => collect((state_7) => str(state_7), parseBefore_4(state_8)))), map((arg0_3) => (new Route_4(1, arg0_3)), (state_10) => str(state_10))]);
    return (state_11) => oneOf(parsers, state_11);
})();

export function beitragCmd(model, pnr) {
    let list2;
    const pnr_1 = replace(pnr, "%20", " ").toUpperCase();
    return map_1((arg) => Cmd_OfFunc_result(new Msg(10, arg)), tryFind((b_2) => (b_2.Vortragsnummer.toUpperCase() === pnr_1), (list2 = collect((tupledArg) => tupledArg[1], toList(model["Beiträge"])), append(collect((tupledArg_1) => tupledArg_1[1], model.Poster), list2))));
}

export function sessionCmd(model, kuerzel) {
    const kuerzel_1 = replace(kuerzel, "%20", " ");
    const r$00E4ume = ofSeq(distinct(collect((x) => x, map_2((t) => map_2((r) => [r.Id, r], t["Räume"]), model.Tage)), {
        Equals: (x_1, y) => equalArrays(x_1, y),
        GetHashCode: (x_1) => arrayHash(x_1),
    }), {
        Compare: (x_2, y_1) => comparePrimitives(x_2, y_1),
    });
    const sessions = ofSeq(choose((tupledArg) => {
        const _arg1 = tupledArg[1];
        if (_arg1.tag === 1) {
            const s = _arg1.fields[0];
            return [s, [FSharpMap__get_Item(r$00E4ume, tupledArg[0]), s]];
        }
        else {
            return void 0;
        }
    }, collect((x_4) => x_4, collect((x_3) => x_3, map_2((t_1) => map_2((a) => toList(a.Programmpunkte), t_1.Achsen), model.Tage)))), {
        Compare: (x_5, y_2) => compare(x_5, y_2),
    });
    return map_1((session) => {
        let tupledArg_1;
        return Cmd_OfFunc_result((tupledArg_1 = FSharpMap__get_Item(sessions, session), new Msg(5, tupledArg_1[0], tupledArg_1[1])));
    }, tryFindKey((s_1, _arg1_1) => {
        if (defaultArg(map_1((k) => {
            if (!isNullOrWhiteSpace(k)) {
                return kuerzel_1.indexOf(k) >= 0;
            }
            else {
                return false;
            }
        }, s_1["Kürzel"]), false)) {
            return true;
        }
        else if (!isNullOrWhiteSpace(s_1["Vortragskürzel"])) {
            return kuerzel_1.indexOf(s_1["Vortragskürzel"]) >= 0;
        }
        else {
            return false;
        }
    }, sessions));
}

export function rahmenCmd(model, bezeichnung) {
    const bezeichnung_1 = decodeURIComponent(bezeichnung);
    return map_1((bez) => Cmd_batch(ofArray([Cmd_OfFunc_result(new Msg(2, new Tab(3))), Cmd_OfFunc_result(new Msg(12, bez))])), tryFind((p) => (p.Bezeichnung === bezeichnung_1), model.Rahmenprogramm));
}

export function urlUpdate(route_1, model) {
    toConsole(printf("urlUpdate %A"))(route_1);
    let pattern_matching_result, pnr, kuerzel, p;
    if (route_1 != null) {
        if (route_1.tag === 0) {
            pattern_matching_result = 0;
        }
        else if (route_1.tag === 1) {
            pattern_matching_result = 1;
            pnr = route_1.fields[0];
        }
        else if (route_1.tag === 4) {
            pattern_matching_result = 2;
            kuerzel = route_1.fields[0];
        }
        else if (route_1.tag === 2) {
            pattern_matching_result = 3;
        }
        else if (route_1.tag === 3) {
            pattern_matching_result = 4;
            p = route_1.fields[0];
        }
        else {
            pattern_matching_result = 5;
        }
    }
    else {
        pattern_matching_result = 0;
    }
    switch (pattern_matching_result) {
        case 0: {
            return [new Model(model.IstAngemeldet, model.AnmeldungAnfordern, model.EigenesProgramm, model.ProfileUrl, model.Tage, model["Ausgewählt"], model.Sprache, model.ZeitenInOrtszeit, void 0, model["Beiträge"], model.Manuskripte, model.Session, model.Programm, model.Beitrag, model.Poster, model.TabSessions, model.Rahmenprogramm, model.Termine, model.Thema, model.RahmenprogrammPunkt), Cmd_none()];
        }
        case 1: {
            const matchValue = beitragCmd(model, pnr);
            if (matchValue == null) {
                return [new Model(model.IstAngemeldet, model.AnmeldungAnfordern, model.EigenesProgramm, model.ProfileUrl, model.Tage, model["Ausgewählt"], model.Sprache, model.ZeitenInOrtszeit, route_1, model["Beiträge"], model.Manuskripte, model.Session, model.Programm, model.Beitrag, model.Poster, model.TabSessions, model.Rahmenprogramm, model.Termine, model.Thema, model.RahmenprogrammPunkt), Cmd_none()];
            }
            else {
                return [new Model(model.IstAngemeldet, model.AnmeldungAnfordern, model.EigenesProgramm, model.ProfileUrl, model.Tage, model["Ausgewählt"], model.Sprache, model.ZeitenInOrtszeit, void 0, model["Beiträge"], model.Manuskripte, model.Session, model.Programm, model.Beitrag, model.Poster, model.TabSessions, model.Rahmenprogramm, model.Termine, model.Thema, model.RahmenprogrammPunkt), matchValue];
            }
        }
        case 2: {
            const matchValue_1 = sessionCmd(model, kuerzel);
            if (matchValue_1 == null) {
                return [new Model(model.IstAngemeldet, model.AnmeldungAnfordern, model.EigenesProgramm, model.ProfileUrl, model.Tage, model["Ausgewählt"], model.Sprache, model.ZeitenInOrtszeit, route_1, model["Beiträge"], model.Manuskripte, model.Session, model.Programm, model.Beitrag, model.Poster, model.TabSessions, model.Rahmenprogramm, model.Termine, model.Thema, model.RahmenprogrammPunkt), Cmd_none()];
            }
            else {
                return [new Model(model.IstAngemeldet, model.AnmeldungAnfordern, model.EigenesProgramm, model.ProfileUrl, model.Tage, model["Ausgewählt"], model.Sprache, model.ZeitenInOrtszeit, void 0, model["Beiträge"], model.Manuskripte, model.Session, model.Programm, model.Beitrag, model.Poster, model.TabSessions, model.Rahmenprogramm, model.Termine, model.Thema, model.RahmenprogrammPunkt), matchValue_1];
            }
        }
        case 3: {
            return [model, Cmd_OfFunc_result(new Msg(2, new Tab(3)))];
        }
        case 4: {
            const matchValue_2 = rahmenCmd(model, p);
            if (matchValue_2 == null) {
                return [new Model(model.IstAngemeldet, model.AnmeldungAnfordern, model.EigenesProgramm, model.ProfileUrl, model.Tage, model["Ausgewählt"], model.Sprache, model.ZeitenInOrtszeit, route_1, model["Beiträge"], model.Manuskripte, model.Session, model.Programm, model.Beitrag, model.Poster, model.TabSessions, model.Rahmenprogramm, model.Termine, model.Thema, model.RahmenprogrammPunkt), Cmd_none()];
            }
            else {
                return [new Model(model.IstAngemeldet, model.AnmeldungAnfordern, model.EigenesProgramm, model.ProfileUrl, model.Tage, model["Ausgewählt"], model.Sprache, model.ZeitenInOrtszeit, void 0, model["Beiträge"], model.Manuskripte, model.Session, model.Programm, model.Beitrag, model.Poster, model.TabSessions, model.Rahmenprogramm, model.Termine, model.Thema, model.RahmenprogrammPunkt), matchValue_2];
            }
        }
        case 5: {
            return [model, Cmd_none()];
        }
    }
}

export function minusIfEmpty(s) {
    if (isNullOrWhiteSpace(s)) {
        return "-";
    }
    else {
        return s;
    }
}

export function tohash(model) {
    let matchValue, beitrag, session, clo1_1, program, clo1_2, r;
    return "#" + (matchValue = [model.Session, model.Programm, model.Beitrag, model["Ausgewählt"], model.RahmenprogrammPunkt], (matchValue[2] != null) ? (beitrag = matchValue[2], toText(printf("%s"))(beitrag.Vortragsnummer)) : ((matchValue[0] != null) ? (session = matchValue[0][1], defaultArg(map_1((clo1_1 = toText(printf("s/%s")), (arg10_1) => clo1_1(arg10_1)), session["Kürzel"]), "")) : ((matchValue[1] != null) ? (program = matchValue[1][1], defaultArg(map_1((clo1_2 = toText(printf("p/%s")), (arg10_2) => clo1_2(arg10_2)), program["Kürzel"]), "")) : ((matchValue[4] != null) ? (r = matchValue[4], toText(printf("r/%s"))(r.Bezeichnung)) : ((matchValue[3] != null) ? ((matchValue[3].tag === 3) ? "r" : "") : "")))));
}

export function alsTermin(model) {
    let beitrag, raum, session, raum_1, session_1, copyOfStruct;
    let _arg1;
    const matchValue = [model.Session, model.Programm, model.Beitrag, model["Ausgewählt"], model.RahmenprogrammPunkt];
    if (matchValue[0] != null) {
        _arg1 = ((matchValue[2] != null) ? (beitrag = matchValue[2], (raum = matchValue[0][0], (session = matchValue[0][1], [beitrag.Vortragsnummer, beitrag.Titel, tryHead(beitrag.Zeiten), beitrag.Dauer, raum.Raum, session["Kürzel"]]))) : (raum_1 = matchValue[0][0], (session_1 = matchValue[0][1], [session_1["Kürzel"], session_1.Bezeichnung, tryHead(session_1.Startzeiten), defaultArg(map_1((list_2) => sumBy((b) => b.Dauer, list_2, {
            GetZero: () => 0,
            Add: (x, y) => (x + y),
        }), tryFind_1(session_1.Id, model["Beiträge"])), 60), defaultArg(session_1.AndererRaum, raum_1.Raum), void 0])));
    }
    else {
        throw (new Error("Noch nicht implementiert"));
    }
    let pattern_matching_result, dauer, id, raum_2, sessionId, titel, zeit;
    if (_arg1[0] != null) {
        if (_arg1[2] != null) {
            pattern_matching_result = 0;
            dauer = _arg1[3];
            id = _arg1[0];
            raum_2 = _arg1[4];
            sessionId = _arg1[5];
            titel = _arg1[1];
            zeit = _arg1[2];
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            return new Termin(id, minusIfEmpty(defaultArg(sessionId, "-")), id, zeit, (copyOfStruct = addMinutes_1(parse(zeit), dauer), toString(copyOfStruct, "yyyy-MM-ddTHH:mm:ss")), titel, raum_2, window.location.href, false);
        }
        case 1: {
            return void 0;
        }
    }
}

export const userId = (() => {
    const container = document.getElementById(fableModule.Platzhalter);
    return container.dataset["user"];
})();

export function init(result) {
    const patternInput = urlUpdate(result, new Model(!isNullOrEmpty(userId), false, false, "", empty(), void 0, "", false, void 0, empty_1(), empty_1(), void 0, void 0, void 0, empty(), empty_1(), empty(), Termine_get(), void 0, void 0));
    return [patternInput[0], Cmd_batch(ofArray([patternInput[1], Cmd_map((arg0) => (new Msg(0, arg0)), query(new Query(0))), Cmd_map((arg0_1) => (new Msg(0, arg0_1)), query(new Query(1))), Cmd_map((arg0_2) => (new Msg(0, arg0_2)), query(new Query(2))), Cmd_map((arg0_3) => (new Msg(0, arg0_3)), query(new Query(4))), Cmd_map((arg0_4) => (new Msg(0, arg0_4)), query(new Query(5))), Cmd_map((arg0_5) => (new Msg(0, arg0_5)), query(new Query(6)))]))];
}

export function tagMitprogramm(tag) {
    return exists((achse) => exists((raum) => {
        const p = FSharpMap__TryFind(achse.Programmpunkte, raum.Id);
        let pattern_matching_result;
        if (p != null) {
            if (p.tag === 0) {
                pattern_matching_result = 0;
            }
            else {
                pattern_matching_result = 0;
            }
        }
        else {
            pattern_matching_result = 1;
        }
        switch (pattern_matching_result) {
            case 0: {
                return true;
            }
            case 1: {
                return false;
            }
        }
    }, tag["Räume"]), tag.Achsen);
}

export const tageMitprogramm = (list) => filter((tag) => tagMitprogramm(tag), list);

export function subscribe(id, termine) {
    return cons(id, termine);
}

export function unsubscribe(id, termine) {
    return filter((t) => (t.Id !== id), termine);
}

export function update(msg, model) {
    let _arg3;
    switch (msg.tag) {
        case 6: {
            const model_2 = new Model(model.IstAngemeldet, model.AnmeldungAnfordern, model.EigenesProgramm, model.ProfileUrl, model.Tage, model["Ausgewählt"], model.Sprache, model.ZeitenInOrtszeit, model.Route, model["Beiträge"], model.Manuskripte, void 0, model.Programm, model.Beitrag, model.Poster, model.TabSessions, model.Rahmenprogramm, model.Termine, model.Thema, model.RahmenprogrammPunkt);
            return [model_2, Navigation_modifyUrl(tohash(model_2))];
        }
        case 7: {
            if (model.IstAngemeldet) {
                const _arg1 = alsTermin(model);
                if (_arg1 != null) {
                    const t = _arg1;
                    return [model, Cmd_map((arg0) => (new Msg(0, arg0)), handle(equals(Model__IstSubscribed_2297AD2E(model, t.Id), new Subscription(0)) ? (new Command(1, t)) : (new Command(0, t))))];
                }
                else {
                    return [model, Cmd_none()];
                }
            }
            else {
                return [new Model(model.IstAngemeldet, true, model.EigenesProgramm, model.ProfileUrl, model.Tage, model["Ausgewählt"], model.Sprache, model.ZeitenInOrtszeit, model.Route, model["Beiträge"], model.Manuskripte, model.Session, model.Programm, model.Beitrag, model.Poster, model.TabSessions, model.Rahmenprogramm, model.Termine, model.Thema, model.RahmenprogrammPunkt), Cmd_none()];
            }
        }
        case 1: {
            return [new Model(model.IstAngemeldet, false, model.EigenesProgramm, model.ProfileUrl, model.Tage, model["Ausgewählt"], model.Sprache, model.ZeitenInOrtszeit, model.Route, model["Beiträge"], model.Manuskripte, model.Session, model.Programm, model.Beitrag, model.Poster, model.TabSessions, model.Rahmenprogramm, model.Termine, model.Thema, model.RahmenprogrammPunkt), Cmd_none()];
        }
        case 14: {
            const session = msg.fields[0];
            if (containsKey(session.Id, model["Beiträge"])) {
                return [model, Cmd_none()];
            }
            else {
                return [model, Cmd_map((arg0_1) => (new Msg(0, arg0_1)), query(new Query(3, session.Id, session["Vortragskürzel"])))];
            }
        }
        case 0: {
            const msg_2 = msg.fields[0];
            if (msg_2.tag === 1) {
                throw (new Error(msg_2.fields[0].message));
            }
            else if (msg_2.tag === 2) {
                return [model, Cmd_map((arg0_2) => (new Msg(0, arg0_2)), query(new Query(6)))];
            }
            else if (msg_2.fields[0].tag === 2) {
                const model_5 = new Model(model.IstAngemeldet, model.AnmeldungAnfordern, model.EigenesProgramm, model.ProfileUrl, model.Tage, model["Ausgewählt"], model.Sprache, model.ZeitenInOrtszeit, model.Route, add(msg_2.fields[0].fields[0], msg_2.fields[0].fields[1], model["Beiträge"]), model.Manuskripte, model.Session, model.Programm, model.Beitrag, model.Poster, model.TabSessions, model.Rahmenprogramm, model.Termine, model.Thema, model.RahmenprogrammPunkt);
                const _arg5 = model_5.Route;
                let pattern_matching_result, pnr_1;
                if (_arg5 != null) {
                    if (_arg5.tag === 1) {
                        pattern_matching_result = 0;
                        pnr_1 = _arg5.fields[0];
                    }
                    else {
                        pattern_matching_result = 1;
                    }
                }
                else {
                    pattern_matching_result = 1;
                }
                switch (pattern_matching_result) {
                    case 0: {
                        return defaultArg(map_1((cmd_2) => [new Model(model_5.IstAngemeldet, model_5.AnmeldungAnfordern, model_5.EigenesProgramm, model_5.ProfileUrl, model_5.Tage, model_5["Ausgewählt"], model_5.Sprache, model_5.ZeitenInOrtszeit, void 0, model_5["Beiträge"], model_5.Manuskripte, model_5.Session, model_5.Programm, model_5.Beitrag, model_5.Poster, model_5.TabSessions, model_5.Rahmenprogramm, model_5.Termine, model_5.Thema, model_5.RahmenprogrammPunkt), cmd_2], beitragCmd(model_5, pnr_1)), [model_5, Cmd_none()]);
                    }
                    case 1: {
                        return [model_5, Cmd_none()];
                    }
                }
            }
            else if (msg_2.fields[0].tag === 3) {
                const model_6 = new Model(model.IstAngemeldet, model.AnmeldungAnfordern, model.EigenesProgramm, model.ProfileUrl, model.Tage, model["Ausgewählt"], model.Sprache, model.ZeitenInOrtszeit, model.Route, model["Beiträge"], model.Manuskripte, model.Session, model.Programm, model.Beitrag, msg_2.fields[0].fields[0], model.TabSessions, model.Rahmenprogramm, model.Termine, model.Thema, model.RahmenprogrammPunkt);
                const _arg6 = model_6.Route;
                let pattern_matching_result_1, pnr_2;
                if (_arg6 != null) {
                    if (_arg6.tag === 1) {
                        pattern_matching_result_1 = 0;
                        pnr_2 = _arg6.fields[0];
                    }
                    else {
                        pattern_matching_result_1 = 1;
                    }
                }
                else {
                    pattern_matching_result_1 = 1;
                }
                switch (pattern_matching_result_1) {
                    case 0: {
                        return defaultArg(map_1((cmd_3) => [new Model(model_6.IstAngemeldet, model_6.AnmeldungAnfordern, model_6.EigenesProgramm, model_6.ProfileUrl, model_6.Tage, model_6["Ausgewählt"], model_6.Sprache, model_6.ZeitenInOrtszeit, void 0, model_6["Beiträge"], model_6.Manuskripte, model_6.Session, model_6.Programm, model_6.Beitrag, model_6.Poster, model_6.TabSessions, model_6.Rahmenprogramm, model_6.Termine, model_6.Thema, model_6.RahmenprogrammPunkt), cmd_3], beitragCmd(model_6, pnr_2)), [model_6, Cmd_none()]);
                    }
                    case 1: {
                        return [model_6, Cmd_none()];
                    }
                }
            }
            else if (msg_2.fields[0].tag === 4) {
                return [new Model(model.IstAngemeldet, model.AnmeldungAnfordern, model.EigenesProgramm, model.ProfileUrl, model.Tage, model["Ausgewählt"], model.Sprache, model.ZeitenInOrtszeit, model.Route, model["Beiträge"], model.Manuskripte, model.Session, model.Programm, model.Beitrag, model.Poster, msg_2.fields[0].fields[0], model.Rahmenprogramm, model.Termine, model.Thema, model.RahmenprogrammPunkt), Cmd_none()];
            }
            else if (msg_2.fields[0].tag === 1) {
                const model_8 = new Model(model.IstAngemeldet, model.AnmeldungAnfordern, model.EigenesProgramm, model.ProfileUrl, model.Tage, model["Ausgewählt"], model.Sprache, model.ZeitenInOrtszeit, model.Route, model["Beiträge"], model.Manuskripte, model.Session, model.Programm, model.Beitrag, model.Poster, model.TabSessions, msg_2.fields[0].fields[0], model.Termine, model.Thema, model.RahmenprogrammPunkt);
                const _arg7 = model_8.Route;
                let pattern_matching_result_2, p;
                if (_arg7 != null) {
                    if (_arg7.tag === 3) {
                        pattern_matching_result_2 = 0;
                        p = _arg7.fields[0];
                    }
                    else {
                        pattern_matching_result_2 = 1;
                    }
                }
                else {
                    pattern_matching_result_2 = 1;
                }
                switch (pattern_matching_result_2) {
                    case 0: {
                        return defaultArg(map_1((cmd_4) => [new Model(model_8.IstAngemeldet, model_8.AnmeldungAnfordern, model_8.EigenesProgramm, model_8.ProfileUrl, model_8.Tage, model_8["Ausgewählt"], model_8.Sprache, model_8.ZeitenInOrtszeit, void 0, model_8["Beiträge"], model_8.Manuskripte, model_8.Session, model_8.Programm, model_8.Beitrag, model_8.Poster, model_8.TabSessions, model_8.Rahmenprogramm, model_8.Termine, model_8.Thema, model_8.RahmenprogrammPunkt), cmd_4], rahmenCmd(model_8, p)), [model_8, Cmd_none()]);
                    }
                    case 1: {
                        return [model_8, Cmd_none()];
                    }
                }
            }
            else if (msg_2.fields[0].tag === 5) {
                return [new Model(model.IstAngemeldet, model.AnmeldungAnfordern, model.EigenesProgramm, model.ProfileUrl, model.Tage, model["Ausgewählt"], model.Sprache, model.ZeitenInOrtszeit, model.Route, model["Beiträge"], ofSeq(map_2((m) => [m.Pnr, m], msg_2.fields[0].fields[0]), {
                    Compare: (x, y) => comparePrimitives(x, y),
                }), model.Session, model.Programm, model.Beitrag, model.Poster, model.TabSessions, model.Rahmenprogramm, model.Termine, model.Thema, model.RahmenprogrammPunkt), Cmd_none()];
            }
            else if (msg_2.fields[0].tag === 6) {
                if (msg_2.fields[0].fields[1]) {
                    Termine_set(msg_2.fields[0].fields[0]);
                }
                return [new Model(model.IstAngemeldet, model.AnmeldungAnfordern, msg_2.fields[0].fields[3], msg_2.fields[0].fields[2].fields[0], model.Tage, model["Ausgewählt"], model.Sprache, model.ZeitenInOrtszeit, model.Route, model["Beiträge"], model.Manuskripte, model.Session, model.Programm, model.Beitrag, model.Poster, model.TabSessions, model.Rahmenprogramm, msg_2.fields[0].fields[1] ? msg_2.fields[0].fields[0] : model.Termine, model.Thema, model.RahmenprogrammPunkt), Cmd_none()];
            }
            else {
                const tage_1 = tageMitprogramm(msg_2.fields[0].fields[0]);
                const model_4 = new Model(model.IstAngemeldet, model.AnmeldungAnfordern, model.EigenesProgramm, model.ProfileUrl, tage_1, (model["Ausgewählt"] != null) ? model["Ausgewählt"] : (_arg3 = tage_1, (_arg3.tail != null) ? (new Tab(0, _arg3.head)) : (void 0)), msg_2.fields[0].fields[1], msg_2.fields[0].fields[2].fields[0], model.Route, model["Beiträge"], model.Manuskripte, model.Session, model.Programm, model.Beitrag, model.Poster, model.TabSessions, model.Rahmenprogramm, model.Termine, model.Thema, model.RahmenprogrammPunkt);
                const _arg4 = model_4.Route;
                let pattern_matching_result_3, pnr, kuerzel;
                if (_arg4 != null) {
                    if (_arg4.tag === 1) {
                        pattern_matching_result_3 = 0;
                        pnr = _arg4.fields[0];
                    }
                    else if (_arg4.tag === 4) {
                        pattern_matching_result_3 = 1;
                        kuerzel = _arg4.fields[0];
                    }
                    else {
                        pattern_matching_result_3 = 2;
                    }
                }
                else {
                    pattern_matching_result_3 = 2;
                }
                switch (pattern_matching_result_3) {
                    case 0: {
                        return [model_4, defaultArg(sessionCmd(model_4, pnr), Cmd_none())];
                    }
                    case 1: {
                        return defaultArg(map_1((cmd_1) => [new Model(model_4.IstAngemeldet, model_4.AnmeldungAnfordern, model_4.EigenesProgramm, model_4.ProfileUrl, model_4.Tage, model_4["Ausgewählt"], model_4.Sprache, model_4.ZeitenInOrtszeit, void 0, model_4["Beiträge"], model_4.Manuskripte, model_4.Session, model_4.Programm, model_4.Beitrag, model_4.Poster, model_4.TabSessions, model_4.Rahmenprogramm, model_4.Termine, model_4.Thema, model_4.RahmenprogrammPunkt), cmd_1], sessionCmd(model_4, kuerzel)), [model_4, Cmd_none()]);
                    }
                    case 2: {
                        return [model_4, Cmd_none()];
                    }
                }
            }
        }
        case 8: {
            const model_9 = new Model(model.IstAngemeldet, model.AnmeldungAnfordern, model.EigenesProgramm, model.ProfileUrl, model.Tage, model["Ausgewählt"], model.Sprache, model.ZeitenInOrtszeit, model.Route, model["Beiträge"], model.Manuskripte, model.Session, [msg.fields[0], msg.fields[1]], model.Beitrag, model.Poster, model.TabSessions, model.Rahmenprogramm, model.Termine, model.Thema, model.RahmenprogrammPunkt);
            return [model_9, Navigation_modifyUrl(tohash(model_9))];
        }
        case 9: {
            const model_10 = new Model(model.IstAngemeldet, model.AnmeldungAnfordern, model.EigenesProgramm, model.ProfileUrl, model.Tage, model["Ausgewählt"], model.Sprache, model.ZeitenInOrtszeit, model.Route, model["Beiträge"], model.Manuskripte, model.Session, void 0, model.Beitrag, model.Poster, model.TabSessions, model.Rahmenprogramm, model.Termine, model.Thema, model.RahmenprogrammPunkt);
            return [model_10, Navigation_modifyUrl(tohash(model_10))];
        }
        case 10: {
            const model_11 = new Model(model.IstAngemeldet, model.AnmeldungAnfordern, model.EigenesProgramm, model.ProfileUrl, model.Tage, model["Ausgewählt"], model.Sprache, model.ZeitenInOrtszeit, model.Route, model["Beiträge"], model.Manuskripte, model.Session, model.Programm, msg.fields[0], model.Poster, model.TabSessions, model.Rahmenprogramm, model.Termine, model.Thema, model.RahmenprogrammPunkt);
            return [model_11, Navigation_modifyUrl(tohash(model_11))];
        }
        case 11: {
            const model_12 = new Model(model.IstAngemeldet, model.AnmeldungAnfordern, model.EigenesProgramm, model.ProfileUrl, model.Tage, model["Ausgewählt"], model.Sprache, model.ZeitenInOrtszeit, model.Route, model["Beiträge"], model.Manuskripte, model.Session, model.Programm, void 0, model.Poster, model.TabSessions, model.Rahmenprogramm, model.Termine, model.Thema, model.RahmenprogrammPunkt);
            return [model_12, Navigation_modifyUrl(tohash(model_12))];
        }
        case 2: {
            const model_13 = new Model(model.IstAngemeldet, model.AnmeldungAnfordern, model.EigenesProgramm, model.ProfileUrl, model.Tage, msg.fields[0], model.Sprache, model.ZeitenInOrtszeit, model.Route, model["Beiträge"], model.Manuskripte, model.Session, model.Programm, model.Beitrag, model.Poster, model.TabSessions, model.Rahmenprogramm, model.Termine, model.Thema, model.RahmenprogrammPunkt);
            return [model_13, Navigation_modifyUrl(tohash(model_13))];
        }
        case 3: {
            const model_14 = new Model(model.IstAngemeldet, model.AnmeldungAnfordern, model.EigenesProgramm, model.ProfileUrl, model.Tage, model["Ausgewählt"], model.Sprache, model.ZeitenInOrtszeit, model.Route, model["Beiträge"], model.Manuskripte, model.Session, model.Programm, model.Beitrag, model.Poster, model.TabSessions, model.Rahmenprogramm, model.Termine, msg.fields[0], model.RahmenprogrammPunkt);
            return [model_14, Navigation_modifyUrl(tohash(model_14))];
        }
        case 4: {
            const model_15 = new Model(model.IstAngemeldet, model.AnmeldungAnfordern, model.EigenesProgramm, model.ProfileUrl, model.Tage, model["Ausgewählt"], model.Sprache, model.ZeitenInOrtszeit, model.Route, model["Beiträge"], model.Manuskripte, model.Session, model.Programm, model.Beitrag, model.Poster, model.TabSessions, model.Rahmenprogramm, model.Termine, void 0, model.RahmenprogrammPunkt);
            return [model_15, Navigation_modifyUrl(tohash(model_15))];
        }
        case 12: {
            const model_16 = new Model(model.IstAngemeldet, model.AnmeldungAnfordern, model.EigenesProgramm, model.ProfileUrl, model.Tage, model["Ausgewählt"], model.Sprache, model.ZeitenInOrtszeit, model.Route, model["Beiträge"], model.Manuskripte, model.Session, model.Programm, model.Beitrag, model.Poster, model.TabSessions, model.Rahmenprogramm, model.Termine, model.Thema, msg.fields[0]);
            return [model_16, Navigation_modifyUrl(tohash(model_16))];
        }
        case 13: {
            const model_17 = new Model(model.IstAngemeldet, model.AnmeldungAnfordern, model.EigenesProgramm, model.ProfileUrl, model.Tage, model["Ausgewählt"], model.Sprache, model.ZeitenInOrtszeit, model.Route, model["Beiträge"], model.Manuskripte, model.Session, model.Programm, model.Beitrag, model.Poster, model.TabSessions, model.Rahmenprogramm, model.Termine, model.Thema, void 0);
            return [model_17, Navigation_modifyUrl(tohash(model_17))];
        }
        default: {
            const s = msg.fields[1];
            const model_1 = new Model(model.IstAngemeldet, model.AnmeldungAnfordern, model.EigenesProgramm, model.ProfileUrl, model.Tage, model["Ausgewählt"], model.Sprache, model.ZeitenInOrtszeit, model.Route, model["Beiträge"], model.Manuskripte, [msg.fields[0], s], model.Programm, model.Beitrag, model.Poster, model.TabSessions, model.Rahmenprogramm, model.Termine, model.Thema, model.RahmenprogrammPunkt);
            return [model_1, Cmd_batch(ofArray([Navigation_modifyUrl(tohash(model_1)), Cmd_OfFunc_result(new Msg(14, s))]))];
        }
    }
}

